import { useDispatch } from 'react-redux'

// Actions
import { actions as audioActions } from 'modules/audio/actions'

// Components
import { Slider, IconSliders } from '@tracklib/kit'

import styles from './filtercontrol.css'

const FilterControl = () => {
  const dispatch = useDispatch()
  return (
    <div className={styles.wrapper}>
      <IconSliders className={styles.icon} />
      <div className={styles.rollover}>
        <Slider
          min={0}
          max={5000}
          values={[0, 5000]}
          onUpdate={value => dispatch(audioActions.updateAudioFilter(value))}
          className={styles.slider}
          vertical
          hideHandleValue
        />
      </div>
    </div>
  )
}

export default FilterControl
